import { render, staticRenderFns } from "./SOrder.vue?vue&type=template&id=64446400&scoped=true&"
import script from "./SOrder.vue?vue&type=script&lang=js&"
export * from "./SOrder.vue?vue&type=script&lang=js&"
import style0 from "./SOrder.vue?vue&type=style&index=0&id=64446400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64446400",
  null
  
)

export default component.exports